import React, { Component } from "react";
import { Field, reduxForm, SubmissionError } from "redux-form";
import TextInput from "../inputs/TextInput";
import { Button } from "../util/Clickable";
import { IntlText } from "../util/Text";
import * as validate from "../util/Validator";
class ValidateForm extends Component {
  state = {
    loading: false,
  };

  onSubmit = (values) => {
    this.setState({
      loading: true,
    });
    return this.props.onSubmit(values).then(({ value, action }) => {
      if (value.status < 300) {
        this.setState(
          {
            loading: false,
          },
          () => {
            this.props.onSuccess &&
              this.props.onSuccess(value.data, value.response);
          },
        );
      } else {
        this.setState({
          loading: false,
        });
        const errors = Object.keys(value.errors).reduce((dic, key) => {
          dic[key] = Array.isArray(value.errors[key])
            ? value.errors[key].join("\n")
            : null;
          return dic;
        }, {});
        throw new SubmissionError(errors);
      }
    });
  };

  render = () => {
    return (
      <form
        onSubmit={this.props.handleSubmit(this.onSubmit)}
        action={this.props.action}
        method="post"
      >
        <div className="uk-margin-small">
          <div className="uk-margin-ssmall">
            <Field
              name="name"
              component={TextInput}
              labelId="forms.attr.name"
              validate={[validate.required]}
              required
            />
          </div>
          <div className="uk-margin-ssmall">
            <Field
              name="password"
              type="password"
              component={TextInput}
              labelId="forms.attr.password"
              validate={[validate.required]}
              required
            />
          </div>

          <div className="uk-margin-ssmall">
            <Field
              name="password_confirmation"
              type="password"
              component={TextInput}
              labelId="forms.attr.password_again"
              validate={[validate.required, validate.isConfirmedPassword]}
              required
            />
          </div>
        </div>

        {(() => {
          if (this.props.error) {
            return (
              <div className="uk-margin-small uk-text-danger uk-text-center@s">
                <span>{this.props.error}</span>
              </div>
            );
          }
        })()}
        <div className="uk-margin-small uk-text-center">
          <Button
            className="uk-button uk-button-default"
            type="submit"
            disabled={this.props.invalid}
            ga={{ category: this.props.form, action: "submit" }}
            loading={this.state.loading ? 1 : 0}
          >
            <IntlText id="forms.submit" />
          </Button>
        </div>
        <Field name="email" type="hidden" component={TextInput} />
        <Field name="init_token" type="hidden" component={TextInput} />
      </form>
    );
  };
}

export default reduxForm({
  form: "validate-form",
  enableReinitialize: true,
})(ValidateForm);
